import { Box, Button, Card, CardActions, CircularProgress, Divider, Typography, useMediaQuery } from '@mui/material';
import moment from 'moment';
import React, { useLayoutEffect, useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { deletePost, getComments, getPost, getSimilarPosts, likePost, searchPosts } from '../../actions/posts';
import LoadingIcon from '../Icons/LoadingIcon/LoadingIcon';
import SuggestedPosts from '../Posts/SuggestedPosts/SuggestedPosts';
import CommentSection from '../CommentSection/CommentSection';
import styles from './styles'; 
import getAverageColors from '../../utils/getAverageColors';
import { useMemo } from 'react';
import placeHolderImage from "../../images/post_placeholder.jpeg";
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import {HiAnnotation} from 'react-icons/hi';
import theme from '../../muiTheme';
import LavaLoader from '../Icons/LavaLoader/LavaLoader';
import UserAvatar from '../UserAvatar/UserAvatar';
import LoadingIcon2 from '../Icons/LoadingIcon2.jsx/LoadingIcon2';
import { hexToRgb } from '../../utils/utils';
import { useRef } from 'react';

const PostDetails = () => {

    const {post, posts, isLoading} = useSelector((state) => state.posts);
    const [similarFetched, setSimilarFetched] = useState(false); 
    const dispatch = useDispatch(); 
    const navigate = useNavigate(); 
    const {id} = useParams(); 
    const [likes, setLikes] = useState([]); 
    const [userLiked, setUserLiked] = useState(false); //return from API, -- in API search for post in User Model's liked posts. 
    const [comments, setComments] = useState([]);
    const [commentsPage, setCommentsPage] = useState(1);
    const [totalComments, setTotalComments] = useState(0);
    const [commentsLoading, setCommentsLoading] = useState(false);
    const commentRef = useRef(null);
    const isMobile = useMediaQuery('(max-width: 768px)');
    const user = JSON.parse(localStorage.getItem('profile'));
    const [colorsFetched, setColorsFetched] = useState(false); 
    const [avColors, setAvColors] = useState({rgb: {r: 0, g: 0, b: 0}, rgb2: {r: 0, g: 0, b: 0}}); 
    const [gradientBackground, setGradientBackground] = useState('linear-gradient(63deg, rgba(238,174,202,1) 0%, rgba(148,187,233,1) 100%)'); 
    const [backgroundColor, setBackgroundColor] = useState('black'); 


    const fetchAVColors = (repeat = true) => {
        if(colorsFetched){
            return; 
        }

        let imageEl = document.getElementById('post-view-mobile-image'); 
        let avColors = {rgb: {r: 0, g: 0, b: 0}, rgb2: {r: 0, g: 0, b: 0}}; 

        if(post && post?.mediaAvColors){

            avColors = JSON.parse(post?.mediaAvColors[0]); //will need to adjust this for arrays of media

            console.log('post avColors: ', avColors);

            avColors.rgb = hexToRgb(avColors.avColor1);
            avColors.rgb2 = hexToRgb(avColors.avColor2);

            console.log('post avColors in rgb: ', avColors);
            setAvColors(avColors);
            setColorsFetched(avColors ? true : false);
        }


        let {r, g, b} = avColors.rgb; 
        let {r:r2, g:g2, b:b2} = avColors.rgb2;

        console.log('avColors: ', avColors);


        let background = `rgb(${r}, ${g}, ${b})`; 
        let gradBackground = `linear-gradient(45deg, rgb(${r}, ${g}, ${b}, 1) 0%, rgb(${r2}, ${g2}, ${b2}, 1) 100%)`; 

        setBackgroundColor(background);
        setGradientBackground(gradBackground);
    }

    useLayoutEffect(()=>{

        if(post?.media.length > 0 && post?.mediaAvColors.length > 0){
            fetchAVColors();
        }
    }, [post]);

    useEffect(()=>{

        dispatch(getPost(id));
        setSimilarFetched(false);
        setColorsFetched(false);

        

    }, [id]);

    useEffect(()=>{

        //recommended posts will be obtained based on tags
        if(post && post._id === id && !similarFetched){

            dispatch(getSimilarPosts(post));

            setSimilarFetched(true);
        }

    }, [post]);

    useEffect(()=>{

        //recommended posts will be obtained based on tags
        if(post){

            console.log('post comments changed');
            setComments([]);

            dispatch(getComments(post._id, commentsPage, (error, res) => {

                if(error){
                    return console.warn('Something went wrong fetching comments: ', error);
                }

                console.log('comments res: ', res);
                if(res.data.length > 0){

                    setComments(res.data);
                }

            }));

            //set post likes
            setLikes(post.likes);

        }

    }, [post, post?.commentCount]);

    const fetchMoreComments = () => {


        console.log('see more comments invoked, comments length: ', comments.length, ' total comments: ', post.commentCount);


        //get updated post first, then fetch comments
        // dispatch(getPost(id), ()=>{


            if(comments.length < post.commentCount ){

                
                console.log('see more comments invoked inside if statement');

                setCommentsLoading(true);

                dispatch(getComments(post._id, commentsPage+1, (error, res) => {
    
                    if(error){
                        return console.warn('Something went wrong fetching comments: ', error);
                    }
        
                    console.log('comments res: ', res);
                    if(res.data.length > 0){
        
                        setComments([
                            ...comments,
                            ...res.data
                        ]);
                    }

                    setCommentsPage(commentsPage+1);

                    setCommentsLoading(false);
        
                }));
            }
        // });

        

        //setCommentsPage(commentsPage+1);        

    }

    const onComment = (comment) => {

        dispatch(getComments(post._id, commentsPage, (error, res) => {

            if(error){
                return console.warn('Something went wrong fetching comments: ', error);
            }

            console.log('comments res: ', res);
            if(res.data.length > 0){

                setComments([
                    ...res.data
                ]);

                
            }

            setTotalComments(res?.total || 0);

        }));
    }

    if(isLoading || post?._id !== id){

        console.log('isLoading, post: ', post);
        return (

            <div style={{width: '100vw', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <LoadingIcon2/>
            </div>
            
        );
    }


    if(!post || typeof post === 'undefined'){

        return (
            <div>
                Post not found
            </div> 
        );

    }

    const handleLikePost = async (event) => {
        if(user?.result){
           dispatch(likePost(post._id));
        }else{
            return
        }

        //Below code is for reflecting like in UI before API responds in case of lengthy response time

        //check if current user liked the post already
        if(likes.find((like) => like === (user?.result?.sub || user?.result?._id))){

            //remove like in UI
            setLikes(likes.filter((id) => id !== (user?.result.googleId || user?.result?._id)));
        } else {

            //add like in UI
            setLikes([...likes, (user?.result?.sub || user?.result?._id)]);

        }
    }

    const Likes = () => {
        if (likes.length > 0) {
          return userLiked
            ? (
              likes.length > 2 ? `You and ${likes.length - 1} others` : `${likes.length} like${likes.length > 1 ? 's' : ''}` 
            ) : (
              `${likes.length}  ${likes.length === 1 ? 'Like' : 'Likes'}`
            );
        }
    
        return '0 Likes'
    };

    //remove current post from posts list
    let suggestedPosts = post.similarPosts ? post.similarPosts.filter(({_id}) => post._id !== _id) : [];
    let imageStyling = isMobile ? 
        {
            maxWidth: '100vw'
        } : 
        {

        };
    
    const openTag = (tag) => {
        var query = {
            search:'none',
            tags: tag
        };

        dispatch(searchPosts(query));

        navigate(`/posts/search?searchQuery=none&tags=${tag}`); 
    }

    const goToComments = () => {

        commentRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }


    const PostActions = () => {

        return (
            <CardActions
                className="cardActions"
                sx={{
                    padding: '5px 10px',
                    // position: 'fixed',
                    // bottom: '5px',
                    // borderRadius: '20px',
                    // background: '#ffffffe3',
                    // width: '100%'
                }}
            >
                <Box
                    sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}
                >

                    <Box
                        color="secondary" 
                        sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}
                        >
                        <FavoriteRoundedIcon onClick={handleLikePost} className="like-icon" style={{fontSize: '30px', color: userLiked ? theme.palette.primary.main : theme.palette.secondary.main}} fontSize='small'/>
                        <Typography variant='body2' color='secondary'>
                            {Likes()}
                        </Typography>
                        

                    </Box>

                    <Box
                        color="secondary" 
                        sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', marginLeft: '30px'}}
                        onClick={goToComments}
                        >
                        <HiAnnotation className="like-icon" style={{fontSize: '30px', color: theme.palette.secondary.main}} fontSize='small'/>
                        <Typography variant='body2' color='secondary'>
                            {post.comments.length} Comment{post.comments.length === 1 ? '' : 's'}
                        </Typography>
                        

                    </Box>

                </Box>
                

                {(user?.result?.sub === post.creator || user?.result?._id === post.creator) && 
                    <Button size="small" color="secondary" onClick={()=>{  dispatch(deletePost(post._id))}}>
                        <DeleteRoundedIcon fontSize='small'/>
                    </Button>
                }
                        

            </CardActions>
        ); 
    }

    

    return (

        <Box style={{...styles.container, top: isMobile? '65px' : '80px'}}>

        
            <Card elevation={0}  sx={styles.card}>


                {
                    post?.media.length > 0 && 

                    <div style={{
                        ...styles.imageSection, 
                        background: gradientBackground, 
                        maxWidth: isMobile ? '100vw' : '70vw', 
                        height: isMobile ? 'calc(100vh - 70px - 65px)' : 'calc(100vh - 80px)', 
                        position: isMobile? 'fixed': 'static'}}>
    
                        <img 
                            id='post-view-mobile-image'
                            style={{...styles.media, ...imageStyling}} 
                            src={post.media?.length > 0 ? post.media[0] : placeHolderImage} alt={post.title} />
    
                    </div>
                }

                

                <div style={{
                    ...styles.section, 
                    minWidth: isMobile ? '100vw': '30vw',
                    marginTop: isMobile && post?.media.length > 0 ? 'calc(100vh - 70px - 65px)' : '0px',
                    background: 'white',
                    position: 'relative',
                    boxSizing: 'border-box'
                    }}>

                    {
                        (isMobile && post?.media.length > 0)  &&

                        <>
                            <PostActions />
                            <Divider style={{ margin: '20px 0' }} />
                        </>
                        
                    }

                    <Box
                        sx={{
                            
                        }}
                    >

                        <UserAvatar url={`/profile/${post.creator._id}`} imageURL={post.creator.profileImage || placeHolderImage} name={post.creator.name} createdAt={post.createdAt} verified={post.creator.verified}/>

                        <Divider style={{ margin: '20px 0' }} />

                        <Typography variant="h6" component="h2">
                            {post.title}
                        </Typography>

                        <div className="details" style={styles.tagContainer}>

                            {post.tags.map((tag, index)=>(
                        
                                <Typography key={tag+index} variant="body2" sx={styles.postTag} color="textSecondary" onClick={()=>openTag(tag)}>
                                    {`#${tag}`}
                                </Typography>
                                
                            ))}
                        </div>
                    </Box>
                    

                    <Typography gutterBottom variant="body1" component="p">
                        {post.message}
                    </Typography>

                    <Divider ref={commentRef} style={{ margin: '20px 0' }} />

                    {
                        (!isMobile || post?.media.length === 0) &&

                        <>
                            <PostActions />
                            <Divider style={{ margin: '20px 0' }} />
                        </>
                        
                    }

                    
                    <CommentSection post={post} loading={commentsLoading} initialComments={comments} fetchMore={(comments.length < post.commentCount)} onFetchMore={fetchMoreComments} onComment={onComment} fixedInput={true}/>
                    
                    

                    <Divider style={{ margin: '20px 0' }} />
                </div>

            </Card>

           

            <div style={{marginTop: isMobile? '0px':'50px', background: 'white', zIndex: '1'}}>
                <SuggestedPosts posts={suggestedPosts}/>
            </div>
            

        </Box>
    );
}

export default PostDetails; 